import { ThemeColorModeProps } from "../utils/cpds-utils";
/* Please refer https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement for more information on HTMLElement*/

// Common properties shared across various components
interface CommonProps extends React.HTMLAttributes<HTMLElement>, ThemeColorModeProps {
  domRef?: React.Ref<HTMLElement>;
  exClasses?: string;
  inputId?: string;
  styleOverrides?: React.CSSProperties;
  inputWidth?: string;
  isError?: boolean;
  ErrorIcon?: string;
  ErrorIconSize?: { width: string, height: string };
  ErrorMessage?: string;
  isOverRideTypography?: boolean;
  isDisabled?: boolean;
  PlaceholderCopy?: string;
  getValue?: React.Dispatch<React.SetStateAction<string>>;
}

// Props related to labels
interface LabelProps extends React.HTMLAttributes<HTMLElement> {
  LabelCopy?: React.ReactNode | string;
  LabelIcon?: string;
  LabelIconSize?: { width: string, height: string };
  LabelIconColor?: string;
}

// Props related to helper texts
interface HelperProps {
  HelperCopy?: string;
  HelperIcon?: string;
  HelperIconSize?: { width: string, height: string };
  HelperIconColor?: string;
}

interface Target {
  checked?: boolean;
  id?: string,
  value?: boolean;
}

interface CheckBoxProps {
  target: Target
}

// Enumeration for border types
export enum BorderType {
  RoundPill = 'RoundPill',
  SquarePill = 'SquarePill'
}

export interface CpdsSweepstakesFormsToolkitsFieldsProps extends CommonProps, LabelProps, HelperProps {
  inputValue?: string;
  SubmitCopy?: string;
  SubmitIcon?: string;
  SubmitIconSize?: { width: string, height: string };
  borderType?: BorderType;
  submitEvent?: (inputValue: string) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setChange?: string;
}

export interface CpdsSweepstakesFormsToolkitsCheckboxProps {
  inputId?: string;
  domRef?: React.Ref<HTMLElement>;
  exClasses?: string;
  styleOverrides?: React.CSSProperties;
  Label?: string;
  Checked?: boolean;
  onChange?: (props: CheckBoxProps) => void;
  getValue?: React.Dispatch<React.SetStateAction<boolean>>;
  isError?: boolean;
  ErrorMessage?: string;
  ErrorIcon?: string;
  ErrorIconSize?: { width: string, height: string };
  isOverRideTypography?: boolean;
  isDisabled?: boolean;
  clickstreamdata?: any;
}

export interface CpdsSweepstakesFormsToolkitsRadioProps extends CpdsSweepstakesFormsToolkitsCheckboxProps{
}

export interface CpdsSweepstakesSelectInputProps extends CommonProps, LabelProps, HelperProps {
  domRef?: React.MutableRefObject<HTMLDivElement>;
  Options?: Array<{ label: string; value: string }>;
  SelectedValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  borderType?: BorderType;
  scrollHeight?: string,
  showSelectedValue?: boolean;
  setChange?: string,
}

export interface CpdsSweepstakesFormsToolkitsPhoneNumberProps extends CommonProps, LabelProps, HelperProps {
  domRef?: React.MutableRefObject<HTMLDivElement>;
  Options?: Array<{ label: string; value: string }>;
  SelectedValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  borderType?: BorderType;
  scrollHeight?: string
}
